/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiRateLimitBucket,
    InternalApiRateLimitBucketFromJSON,
    InternalApiRateLimitBucketToJSON,
    InternalApiRateLimitConfiguration,
    InternalApiRateLimitConfigurationFromJSON,
    InternalApiRateLimitConfigurationToJSON,
} from '../models';

export interface DeleteRateLimitBucketRequest {
    bucketName: string;
}

export interface UpdateDefaultRateLimitRequest {
    defaultRateLimitSeconds: number;
}

export interface UpdateRateLimitBucketRequest {
    internalApiRateLimitBucket: InternalApiRateLimitBucket;
}

/**
 * 
 */
export class RateLimitApi extends runtime.BaseAPI {

    /**
     */
    async deleteRateLimitBucketRaw(requestParameters: DeleteRateLimitBucketRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.bucketName === null || requestParameters.bucketName === undefined) {
            throw new runtime.RequiredError('bucketName','Required parameter requestParameters.bucketName was null or undefined when calling deleteRateLimitBucket.');
        }

        const queryParameters: any = {};

        if (requestParameters.bucketName !== undefined) {
            queryParameters['bucketName'] = requestParameters.bucketName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/rate-limit`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteRateLimitBucket(requestParameters: DeleteRateLimitBucketRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteRateLimitBucketRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getRateLimitConfigRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiRateLimitConfiguration>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/rate-limit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiRateLimitConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async getRateLimitConfig(initOverrides?: RequestInit): Promise<InternalApiRateLimitConfiguration> {
        const response = await this.getRateLimitConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDefaultRateLimitRaw(requestParameters: UpdateDefaultRateLimitRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.defaultRateLimitSeconds === null || requestParameters.defaultRateLimitSeconds === undefined) {
            throw new runtime.RequiredError('defaultRateLimitSeconds','Required parameter requestParameters.defaultRateLimitSeconds was null or undefined when calling updateDefaultRateLimit.');
        }

        const queryParameters: any = {};

        if (requestParameters.defaultRateLimitSeconds !== undefined) {
            queryParameters['defaultRateLimitSeconds'] = requestParameters.defaultRateLimitSeconds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/rate-limit`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateDefaultRateLimit(requestParameters: UpdateDefaultRateLimitRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateDefaultRateLimitRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateRateLimitBucketRaw(requestParameters: UpdateRateLimitBucketRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiRateLimitBucket === null || requestParameters.internalApiRateLimitBucket === undefined) {
            throw new runtime.RequiredError('internalApiRateLimitBucket','Required parameter requestParameters.internalApiRateLimitBucket was null or undefined when calling updateRateLimitBucket.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/rate-limit`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiRateLimitBucketToJSON(requestParameters.internalApiRateLimitBucket),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateRateLimitBucket(requestParameters: UpdateRateLimitBucketRequest, initOverrides?: RequestInit): Promise<void> {
        await this.updateRateLimitBucketRaw(requestParameters, initOverrides);
    }

}
